import { Box, Heading, Spacer, Stack } from '@chakra-ui/react'
import 'swiper/swiper-bundle.css'

import UserQ from '@/queries/UserQ'
import UserVolunteerRoleQ from '@/queries/UserVolunteerRoleQ'
import type { Query } from '@/client/query'
import { getSortedAchievements, PROGRESSION_DEFAULT } from '@/client/services/progression'

import BadgeList from '@/components/Achievements/BadgeList'

export default function ProfileBadges({
  user,
  limit,
  ButtonComponent = () => <Spacer />,
}: {
  user: Query
  limit?: number | null
  ButtonComponent?: () => JSX.Element
}): JSX.Element | null {
  const userVolunteerRoles = user.many(UserVolunteerRoleQ.where({ userId: UserQ.id }))
  const progression = user(UserQ.progression) ?? PROGRESSION_DEFAULT
  const achievementIds = getSortedAchievements({
    progression,
    completed: true,
  })

  return (
    <Box>
      <Stack spacing={2} direction="row" justify="space-between" align="center" mb={1}>
        <Heading size="xl" as="h2" mb={5}>
          Badges
        </Heading>
        <Spacer />
        <ButtonComponent />
      </Stack>
      <BadgeList
        userVolunteerRoles={userVolunteerRoles}
        achievementIds={achievementIds}
        progression={progression}
        limit={limit}
      />
    </Box>
  )
}
